import type { Station } from '@/content/schema';

const SKILL_LABEL: Record<Station['skills'][number], string> = {
  fullstack: 'Full-stack',
  'csharp-fsharp': 'C# / F#',
  bim: 'BIM / IFC',
  ai: 'Applied AI',
  leadership: 'Leadership',
};

export function ChapterPanel({ station }: { station: Station }) {
  const Heading = station.index === 0 ? 'h1' : 'h2';
  const paragraphs = station.body
    .split(/\n\s*\n/)
    .map((p) => p.trim())
    .filter(Boolean);

  return (
    <section key={station.id} className="chapter" aria-live="polite">
      <p className="kicker">
        {String(station.index + 1).padStart(2, '0')} · {station.index === 0 ? 'Intro' : 'Station'}
      </p>
      <Heading>{station.title}</Heading>
      {station.subtitle && <p className="subtitle">{station.subtitle}</p>}
      {station.project && (
        <p className="project">
          <strong>{station.project.name}</strong>
          {station.project.client ? ` · ${station.project.client}` : ''} · {station.project.years}
        </p>
      )}
      {paragraphs.map((p, i) => (
        <p key={i}>{p}</p>
      ))}
      {(station.skills.length > 0 || station.project) && (
        <div className="skills">
          {station.skills.map((s) => (
            <span key={s} className="skill">
              {SKILL_LABEL[s]}
            </span>
          ))}
          {station.project?.stack.map((s) => (
            <span key={s} className="skill stack">
              {s}
            </span>
          ))}
        </div>
      )}
    </section>
  );
}
